import React from 'react';
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import compose from 'lodash.compose';
import Link from '../../link'

function KitDetailsPressurePlate({ t, product, i18n: { language } }) {
  return (
    <Link href={`/product/pressure-plate-${product.code}/${product._id}`}>
      <a className="div-table-row">
        <div className="div-table-cell">{product.code}</div>
        <div className="div-table-cell">{t('types.PressurePlate')}</div>
        <div className="div-table-cell">{product[`description_${language}`] || t('pressure_plate_details.title')}</div>
      </a>
    </Link>
  );
}

KitDetailsPressurePlate.defaultProps = {};
KitDetailsPressurePlate.propTypes = {
  product: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    description_en: PropTypes.string,
    description_it: PropTypes.string,
  })
};

export default compose(
  translate('product'),
)(KitDetailsPressurePlate);
